
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };

export { makeRenderlessComponent };
//# sourceMappingURL=make-renderless-component.mjs.js.map
